module.exports = __webpack_public_path__ + "img/Christmas_Tree.128f41c4.svg";